import PageContainer from '@/components/PageContainer';

import { Box, Button, Card, Typography } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { FC } from 'react';
import { useFirequery } from '@ajorquera/libs/react';
import { clinicCrud } from '@/services/firebase';
import { Clinic } from '@/types/database';
import { useAuth } from '@/components/auth';

const ICON_SIZE = 120;
const BUTTON_STYLE = {
  color: 'black',
  p: 2,
  mb: 2,
  '&:hover': { backgroundColor: '#f7f7f7' },
};

interface Props {
  manage?: string[];
}

const AdminDashboardPage: FC<Props> = ({ manage }) => {
  const { clinicId: clinicIdParam } = useParams<{ clinicId: string }>();
  const { user } = useAuth();

  const clinicId = clinicIdParam || user?.managedClinicId;

  const {
    data: clinicData,
    loading,
    error,
  } = useFirequery<Clinic>(clinicCrud.query(clinicId as string), { disabled: !clinicId });

  return (
    <PageContainer
      loading={loading}
      error={error?.message}
      sx={{ height: '100%' }}
      title={clinicData?.name}
      description="adminDashboardDescription"
    >
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center', mt: 5 }}>
        {manage?.map((entity, i) => {
          const props = ENTITY_MANAGE[entity];

          if (!props) return null;

          return (
            <Box key={i}>
              <Link to={props.to}>
                <Card sx={BUTTON_STYLE}>
                  <Icon icon={props.icon} width={ICON_SIZE} height={ICON_SIZE} />
                </Card>
              </Link>
              <Typography fontWeight="bold" textAlign="center" variant="h2">
                {props.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </PageContainer>
  );
};

const ENTITY_MANAGE: Record<string, any> = {
  administrators: {
    icon: 'eos-icons:admin',
    label: 'Administrators',
    to: 'clinic-admins',
  },
  clinics: {
    icon: 'healthicons:ambulatory-clinic',
    label: 'Clinic',
    to: 'clinics',
  },
  doctors: {
    icon: 'vaadin:doctor',
    label: 'Doctors',
    to: 'doctors',
  },
  patients: {
    icon: 'fluent:patient-24-filled',
    label: 'Patients',
    to: 'patients',
  },
};

export default AdminDashboardPage;
